// import external dependencies
import 'jquery';
import 'custom-event-polyfill';
import 'nodelist-foreach-polyfill';
import 'objectFitPolyfill';

// Import everything from autoload
import './autoload/_bootstrap.js'

// Import lightbox
import 'lightbox2';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import cookies from './routes/cookies';
import investors from './routes/investors';
import search from './routes/search';
import products from './routes/products';
import documents from './routes/documents';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  cookies,
  investors,
  search,
  products,
  documents,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js